import { CptCodesTableRowModel } from "../../../../../data-model/cptCodesTableModel";
import { MedicalPaOrder } from "../../../../../data-model/medicalPaOrdersModel";
import { updateTableDataState } from "./updateTableDataState";

export const revertTableToLastStateOnClose = (data?: {
  rowIndex: number;
  fieldKey: string;
  fieldValue: any;
  singleMedicalPaOrder: MedicalPaOrder;
  originalTableData: CptCodesTableRowModel[];
  setTableData: React.Dispatch<React.SetStateAction<CptCodesTableRowModel[]>>;
  setHasChanges: React.Dispatch<React.SetStateAction<boolean>>;
  saveTableDataToLocalStorage: (data: CptCodesTableRowModel[]) => void;
}) => {
  if (!data) return;
  updateTableDataState(
    data.rowIndex,
    data.fieldKey,
    data.fieldValue,
    data.singleMedicalPaOrder ?? {},
    data.originalTableData,
    data.setTableData,
    data.setHasChanges,
    data.saveTableDataToLocalStorage,
  );
};
